import BaseService from './baseService'
const serviceURL = '/api/v1/account'

export default class AccountService extends BaseService {
  isThirdPartyUser = false
  username = null
  passwordExpired = false
  forgotPassword = false
  setPasswordExpired(passwwordChangedDate = null) {
    if (passwwordChangedDate) {
      const changedDate = new Date(passwwordChangedDate)
      const currentDate = new Date()
      const diffTime = Math.abs(currentDate - changedDate)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      this.passwordExpired = diffDays > 60
    } else {
      this.passwordExpired = true
    }
  }
  setIsForgetPassword() {
    const localStorageKey = localStorage.getItem('forgotPassword')
    if (localStorageKey === 'true') {
      this.forgotPassword = true
      return
    }

    this.forgotPassword = false
  }

  async login(apiAccessToken) {
    return this.sendNoAuthRequest(
      'POST',
      `${serviceURL}/SignIn`,
      null,
      {
        Authorization: `Bearer ${apiAccessToken}`,
        'MsGraph-Auth-Token': apiAccessToken
      }
    ).then(response => {
      if (response && response.data && response.data.authenticationToken) {
        localStorage.setItem('user-token', response.data.authenticationToken)
      }

      return response
    })
  }


  async customLogin(payload) {
    return this.sendNoAuthRequest('POST', `${serviceURL}/CustomLogin`, payload)
  }

  async getUserRole(username) {
    return this.sendNoAuthRequest('GET', `${serviceURL}/GetUserRole/?username=${username}`)
  }
  async changePassword(payload) {
    return this.sendRequest('POST', `${serviceURL}/ChangePassword`, payload)
  }
  async verifyUserToken(token) {
    return this.sendNoAuthRequest('POST', `${serviceURL}/ValidateUserToken/?token=${token}`)
  }
  async sendVerificationCode(username) {
    return this.sendNoAuthRequest('POST', `${serviceURL}/send-verification-code/${username}`)
  }

  async verifyCode(payload) {
    return this.sendNoAuthRequest('POST', `${serviceURL}/verify-code`, payload)
  }

  async validateNewUser(username) {
    return this.sendNoAuthRequest('POST', `${serviceURL}/validateUserInfo/?username=${username}`)
  }
  async getUserInfo(username) {
    return this.sendRequest('POST', `${serviceURL}/validateUserInfo/?username=${username}&onlyNewUser=false`)
  }
}
